// extracted by css-extract-rspack-plugin
export default {"tableControlsContainer":"tableControlsContainer-YGRKXL","tableControlsItemIcon":"tableControlsItemIcon-U8hA3R"};